// extracted by mini-css-extract-plugin
module.exports = {"Container":"SuccessScreen_Container__nnsl6","Countdown":"SuccessScreen_Countdown__39R_K"};